<template>
    <div>
        <div class="section">
            <h1 class="title is-uppercase">{{ title }}</h1>
        </div>

        <div class="section">
            <b-message v-if="sended.message" type="is-success" has-icon>
                <p v-text="sended.message"></p>
            </b-message>
        </div>

        <div id="store-form" class="section">
            <b-field :label="__('strings.store.form.name')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.name }"
                     :message="errors.name">
                <b-input :placeholder="__('strings.store.form.name')"
                         type="name" name="name"
                         v-model="input.name" @focus="clearError"></b-input>
            </b-field>

            <b-field :label="__('strings.store.form.code')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.code }"
                     :message="errors.code">
                <b-input :placeholder="__('strings.store.form.code')"
                         type="code" name="code"
                         v-model="input.code" @focus="clearError"></b-input>
            </b-field>

            <b-field :label="__('strings.store.form.magento_id')"
                     label-position="on-border"
                     :type="{ 'is-danger': errors.magento_id }"
                     :message="errors.magento_id">
                <b-input :placeholder="__('strings.store.form.magento_id')"
                         type="magento_id" name="magento_id"
                         v-model="input.magento_id" @focus="clearError"></b-input>
            </b-field>

            <b-field
                :type="{ 'is-danger': errors.website_id }"
                :message="errors.website_id">
                <b-select
                    :placeholder="__('strings.store.form.website_id')"
                    v-model="input.website_id"
                    expanded>
                    <option v-for="website in websites" :key="website.id" :value="website.id">
                        {{
                            `id: ${website.id} - ${website.name} - code: ${website.code} - magento_id: ${website.magento_id}`
                        }}
                    </option>
                </b-select>
            </b-field>

            <div class="field">
                <b-button
                    tag="button"
                    type="is-primary"
                    class="is-uppercase"
                    :label="__('strings.form.submitButton')"
                    @click.prevent="submit"
                    rounded
                    outlined
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: {
                name: "",
                code: "",
                magento_id: "",
                website_id: null,
            },
            websites: [],
            errors: {
                name: "",
                code: "",
                magento_id: "",
                website_id: "",
            },
            sended: {
                message: ''
            },
            item: null
        };
    },
    mounted() {
        if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
            console.log(this.$route.params.routeKey);
            axios.get('/store/edit/' + this.$route.params.routeKey)
                .then(response => {

                    this.item = response.data
                    this.input = Object.assign({}, response.data)
                })
        }
    },
    created() {
        axios.get('/website/index')
            .then(response => {
                this.websites = Object.assign([], response.data.data);
            })
    },
    methods: {
        submit() {
            let method = this.item ? 'patch' : 'post';
            let url = this.item ? `/update/store/${this.$route.params.routeKey}` : '/store/store';
            axios({method, url, data: this.input})
                .then(response => {
                    let translationKey = this.item ? 'messages.model.updated' : 'messages.model.created'
                    this.sended.message = this.__(translationKey, {name: this.__('strings.models.store')})

                    if (!this.item) {
                        this.$router.push({
                            name: 'model.action',
                            params: {
                                resource: 'store',
                                action: 'edit',
                                routeKey: response.data.id
                            }
                        });
                    }

                    this.item = Object.assign({}, response.data)
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
        },
        clearError(event) {
            this.errors[event.target.name] = "";
        }
    },
    computed: {
        title() {
            let translationKey = this.item ? 'strings.store.form.editTitle' : 'strings.store.form.title';
            return this.__(translationKey);
        }
    }
};
</script>
